import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class OrganisationClient extends ApplicationRecord {
  static jsonapiType = "organisation_clients";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) briefCount: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() name: string;

  @Attr() notes: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() position: number;

  @Attr({ persist: false }) updatedAt: string;
}

export default OrganisationClient;
